<template>
  <div id="ff_body">
    <vue-topprogress ref="topProgress" :color="'#27aef5'"></vue-topprogress>
    <router-view v-if="isRouterAlive" ref="myChild" />
    <div class="banquan">
      <p class="p1">北京智步云上科技有限公司 备案/许可证编号：<a style="color:gray;" target="_blank" href="https://beian.miit.gov.cn/">京ICP备2024066658号</a></p>
    </div>
    <!-- <sock/> -->
  </div>
</template>

<script>
// import sock from './components/Sock/sock.vue'
import { vueTopprogress } from 'vue-top-progress';
import appRouter from '@/assets/js/appRouter.js';
import './assets/js/directives'
import { toMQ } from '@/components/Sock/RabbitMQ'
export default {
  provide() {
    return {
      reload: this.reload //声明一个变量
    }
  },
  components: {
    vueTopprogress,
    // sock
  },
  props: [],
  data() {
    return {


      isRouterAlive: true //控制router-view是否显示达到刷新的效果
    }
  },
  methods: {
    //provide中声明的变量
    reload() {
      //通过this.isRouterAlive控制router-view达到刷新效果
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  beforeCreate() {
    var userID = JSON.parse(localStorage.getItem('user_data')).id;
    toMQ(userID);
  },
  mounted() {
    appRouter(this);
    this.$router.beforeEach((to, from, next) => {
      this.$refs.topProgress.start();
      next();
    });
    this.$router.afterEach((to, from) => {
      document.getElementsByTagName('title')[0].innerHTML = this.$route.meta.tagName || '';
      setTimeout(() => {
        this.$refs.topProgress.done();
      }, 300)
    });
  }
}
</script>

<style lang="less">
@import "assets/common/css/reset.css";
@import "assets/common/css/variable.less";

html,
body {
  width: 100%;
  height: 100%;
  // position: relative;
}

#ff_body {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  background-color: #fff;
  // overflow-y: hidden;
  // z-index: 9999;
}

.banquan {
  float: left;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  background: gainsboro;
  font-size: 14px;
  color: grey;
}
</style>
